(function () {
  const form = document.querySelector('.petlee-popup-wrap');
  if (!form) return;

  const delayInput = form.querySelector('#WelcomePopup-delay');
  const delaySeconds = delayInput ? parseInt(delayInput.value, 10) || 8 : 8;
  const step1 = form.querySelector('[data-step="1"]');
  const step2 = form.querySelector('[data-step="2"]');
  const closeBtn = form.querySelector('.petlee-popup__close');
  const doneBtn = form.querySelector('.petlee-popup__done');
  const emailInput = form.querySelector('#WelcomePopup-email');
  const errMsg = form.querySelector('#WelcomePopup-err');

  const STORAGE_KEY = 'petlee_welcome_popup_seen';

  function hasBeenShownThisSession() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function markShownThisSession() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (err) {
      /* private browsing or storage disabled — falls back to once-per-page-load */
    }
  }

  // Shopify renders every page as a fresh load (unlike the single-page prototype),
  // so "once per visit" has to be tracked across page loads via sessionStorage —
  // it clears when the browser tab closes, matching "once when you enter the site."
  let seen = hasBeenShownThisSession();

  function showStep(step) {
    step1.style.display = step === 1 ? 'block' : 'none';
    step2.style.display = step === 2 ? 'block' : 'none';
  }

  function show() {
    if (seen || form.classList.contains('is-open')) return;
    form.classList.add('is-open');
    seen = true;
    markShownThisSession();
    if (emailInput) setTimeout(() => emailInput.focus(), 240);
  }

  function hide() {
    form.classList.remove('is-open');
    seen = true;
    markShownThisSession();
  }

  showStep(1);

  closeBtn.addEventListener('click', hide);
  form.addEventListener('click', (e) => {
    if (e.target === form) hide();
  });
  doneBtn.addEventListener('click', hide);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') hide();
  });

  // Reveal the code instantly on the client, then try to record the subscriber
  // in the background — Shopify's own spam checks on /contact can block or
  // challenge that request, but the shopper should never be stuck waiting on it.
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const value = (emailInput.value || '').trim();
    const valid = /^\S+@\S+\.\S+$/.test(value);
    if (!valid) {
      errMsg.classList.add('show');
      return;
    }
    errMsg.classList.remove('show');
    showStep(2);

    try {
      fetch(form.action.split('#')[0], {
        method: 'POST',
        mode: 'no-cors',
        body: new FormData(form),
      });
    } catch (err) {
      /* best-effort only */
    }
  });

  if (!seen) {
    setTimeout(show, delaySeconds * 1000);
    document.addEventListener('mouseout', (e) => {
      if (!seen && !e.relatedTarget && e.clientY <= 0) show();
    });
  }
})();
